import { connectHighlight } from 'react-instantsearch-dom';
import { Text } from "@chakra-ui/react"


const Highlight = ({ highlight, attribute, hit }) => {
  const parsedHit = highlight({
    highlightProperty: '_highlightResult',
    attribute,
    hit,
  });

  return (
    <Text fontSize="smaller">
      {parsedHit.map(
        (part, index) =>
          part.isHighlighted ? (
            <mark key={index}>{part.value}</mark>
          ) : (
            <span key={index}>{part.value}</span>
          )
      )}
    </Text>
  );
};

const CustomHighlight = connectHighlight(Highlight);

export default CustomHighlight